import {Routes, Route, Navigate} from "react-router-dom";
import {strings} from "strings";

import PharmacyLookupPage from "pages/PharmacyLookupPage";
import RedirectPage from "pages/RedirectPage";

import styles from "./App.module.css";

function App() {
  return (
    <div className={styles.container}>
      <div className={styles.header}>{strings.title}</div>
      <div className={styles.content}>
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<PharmacyLookupPage />} />
          <Route path="/navigate-page" element={<RedirectPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
